<div class="revert-mfa-wrapper">
  @if (loading()) {
    <mat-spinner></mat-spinner>
  } @else if (completed()) {
    <mat-card class="revert-mfa-card">
      <mat-card-header class="revert-mfa-header">
        <div class="logo" role="img" aria-label="Damotech"></div>
        <div class="title">{{ 'auth.mfa.revert.success.title' | translate }}</div>
        <div class="description">{{ 'auth.mfa.revert.success.description' | translate }}</div>
      </mat-card-header>
      <mat-card-actions class="revert-mfa-actions">
        <a mat-flat-button color="primary" class="btn" [routerLink]="['../', 'sign-in']" [queryParams]="{ mfaRevoked: true }">
          {{ 'auth.mfa.revert.success.signIn' | translate }}
        </a>
      </mat-card-actions>
    </mat-card>
  } @else if (!errorMessage()) {
    <mat-card class="revert-mfa-card">
      <mat-card-header class="revert-mfa-header">
        <div class="logo" role="img" aria-label="Damotech"></div>
        <div class="title">{{ 'auth.mfa.revert.title' | translate }}</div>
        <div class="description">{{ 'auth.mfa.revert.description' | translate: { factor: factorName() } }}</div>
      </mat-card-header>
      <div class="revert-mfa-content">
        <mat-card-content>
          <form [formGroup]="form" (ngSubmit)="confirm()">
            <mat-checkbox formControlName="confirmation">{{ 'auth.mfa.revert.confirmation' | translate }}</mat-checkbox>
            <button mat-flat-button color="primary" type="submit" class="btn" [disabled]="applying()">
              @if (applying()) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                {{ 'auth.mfa.revert.submit' | translate }}
              }
            </button>
          </form>
        </mat-card-content>
      </div>
    </mat-card>
  } @else {
    <mat-card class="revert-mfa-card">
      <mat-card-header class="revert-mfa-header">
        <div class="logo" role="img" aria-label="Damotech"></div>
        <div class="title">{{ 'auth.mfa.revert.error.title' | translate }}</div>
      </mat-card-header>
      <div class="revert-mfa-content">
        <mat-card-content>
          <p class="error-message">{{ errorMessage() | translate }}</p>
          <p class="description">{{ 'auth.mfa.revert.error.description' | translate }}</p>
        </mat-card-content>
        <mat-card-actions class="revert-mfa-actions">
          <div class="back">
            <a mat-button [routerLink]="['../', 'sign-in']" class="back-to-sign-in-link">
              {{ 'auth.mfa.revert.error.signIn' | translate }}
            </a>
          </div>
        </mat-card-actions>
      </div>
    </mat-card>
  }
</div>
